import {API_V1_URL} from "../../constants/other"
import http from "../../http"

const ROLES_URL = `${API_V1_URL}/roles/`


export const getRoles = (params) => http.get(ROLES_URL, {params})

export const getPermissions = () => http.get(`${ROLES_URL}permissions`)
